import { abbreviateNumber } from '@fabric-ui/utils';

export const formatTooltipNumberValue = (value: unknown): string | number | undefined => {
  if (value === null || value === undefined || value === '') {
    return value as undefined;
  }

  if (typeof value === 'number') {
    return String(abbreviateNumber(value));
  }

  if (typeof value === 'string') {
    const normalizedValue = value.replace(/,/g, '').trim();
    if (/^-?\d+(\.\d+)?$/.test(normalizedValue)) {
      return String(abbreviateNumber(Number(normalizedValue)));
    }
  }

  return value as string | number;
};
